module.exports = __webpack_public_path__ + "static/img/title.b884b04.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/news2/title.png
// module id = K5/q
// module chunks = 7